import React from "react";

const ButtonsGroup = props => {
    const {className, role = 'group', position = '', children, ...other} = props;
    const positionClass = position.toLowerCase() === 'right' ? ' ch-buttons-group-right' : '';
    return (
        <div role={role} className={"ch-buttons-group" + positionClass + (className ? ' ' + className : '')} {...other}>{children}</div>
    )
}

export default ButtonsGroup;